import { NgModule, Injector } from '@angular/core';
import { TelemedicineComponent } from './components/telemedicine/telemedicine.component';
import { TelemedicineService } from './services/telemedicine.service';
import { CommonModule } from '@angular/common';
import { EndCallMessageComponent } from './components/endcallmessage/end-call-message.component';
import { KxSharedModule } from '../kx-shared/kx-shared.module';
import { TelemedicineModalComponent } from './components/telemedicine-modal/telemedicine-modal.component';
import { AppService } from '../base/shared/services/app.service';
import { AgoraService } from './services/agora.service';
import { TelemedicineGuestPageComponent } from './components/telemedicine-guest-page/telemedicine-guest-page.component';

@NgModule({
  declarations: [
    TelemedicineComponent,
    EndCallMessageComponent,
    TelemedicineModalComponent,
    TelemedicineGuestPageComponent,
  ],
  imports: [
    CommonModule,
    KxSharedModule
  ],
  providers: [
    TelemedicineService,
    AgoraService
  ],
  exports:[
    TelemedicineComponent,
  ]
})
export class TelemedicineModule { 
  public entryComponents:any =  [
    TelemedicineComponent,
    EndCallMessageComponent,
    TelemedicineModalComponent,
    // PatientViewQueueComponent
  ]

  public appService: AppService;
  constructor(public injector: Injector){
    this.appService = injector.get(AppService);
    this.appService._factories["modules"]["TelemedicineModule"] = this.entryComponents;
    if( this.entryComponents &&  this.entryComponents.length){
      this.appService.buildFactory(this.entryComponents);
    }
  }
}
